export const regexMqttHost = /^(.\S{1,}\S)$/;
export const regexIsInt = /^([0-9]{1,})$/;
